import { Divider, Stack } from "@mui/material";
import { PAGINATION, SYSTEMS } from "../../../constants";

import { BACKEND_ROUTES } from "../../../backendRoutes";
import { ContractDetailsSkeleton } from "../ContractDetailsSkeleton";
import { ContractForm } from "./ContractForm";
import { FetchErrorAlert } from "../../../components/FetchErrorAlert";
import { PipelineTemplateTable } from "../../pipeline-template/PipelineTemplateTable";
import { ProcessingCommentsModal } from "./ProcessingCommentsModal";
import { SiteTable } from "../../site";
import { useIsBasicRole } from "../../../hooks";
import { useMemo } from "react";
import useSWR from "swr";

export const ContractManagement = ({ contract, mutateContract }) => {
    const isBasicRole = useIsBasicRole();

    const {
        data: pipelineTemplates,
        error: pipelineTemplateFetchError,
        mutate: mutatePipelineTemplate,
    } = useSWR(
        `${BACKEND_ROUTES.PIPELINE_TEMPLATE}?parentInfo=true&contractUuid=${contract.uuid}&limit=${PAGINATION.GENERIC.LIMIT.MAX}`
    );

    const hasLiteralTemplates = useMemo(
        () =>
            pipelineTemplates?.rows.some(
                (pipeline) =>
                    pipeline.AcquisitionVector.SystemModel.system ===
                    SYSTEMS.LITERAL
            ),
        [pipelineTemplates]
    );

    if (pipelineTemplateFetchError)
        return <FetchErrorAlert error={pipelineTemplateFetchError} />;
    if (!pipelineTemplates) return <ContractDetailsSkeleton />;
    return (
        <>
            <Stack spacing={2}>
                <ContractForm contract={contract} mutate={mutateContract} />
                <Divider />
                <PipelineTemplateTable
                    contractUuid={contract.uuid}
                    pipelineTemplates={pipelineTemplates.rows}
                    mutate={mutatePipelineTemplate}
                />
                <Divider />
                <SiteTable
                    contract={contract}
                    hasLiteralTemplates={hasLiteralTemplates}
                />
            </Stack>
            {!isBasicRole && (
                <ProcessingCommentsModal
                    contract={contract}
                    mutate={mutateContract}
                />
            )}
        </>
    );
};
